import React from 'react'
import connected from "./../images/connected.png"
import secured from "./../images/secured.png"
import handshake from "./../images/handshake.png"

function WhyUs() {
    return (
        <section id="whyus" className='bg-200'>
            <div className="container">
                <div className="row flex-center">
                    <div className="row mb-4 mt-3">
                        <div className="col-md-6 col-lg-4 text-center"><img src={connected} alt="Dashboard" style={{widows: 100, height: 100}} />
                            <h4 className="mt-3 lh-base">Access to Opportunities</h4>
                            <p className="fs-0">Discover real opportunities to offer your skills and earn. From local tasks to specialized projects, we make it easy to connect with people who need your hustle.</p>
                        </div>
                        <div className="col-md-6 col-lg-4 text-center"><img src={secured} alt="Dashboard" style={{widows: 100, height: 100}} />
                            <h4 className="mt-3 lh-base">Safe & Transparent Transactions</h4>
                            <p className="fs-0">Work and pay with confidence. Every transaction is secure, every provider verified, and every request tracked, so you can focus on delivering value</p>
                        </div>
                        <div className="col-md-6 col-lg-4 text-center"><img src={handshake} alt="Dashboard" style={{widows: 100, height: 100}} />
                            <h4 className="mt-3 lh-base">Grow Your Skills & Network</h4>
                            <p className="fs-0">Meet other hustlers, learn from their journey, and expand your reach. Build relationships that open doors you didn’t even know existed.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default WhyUs
